module.exports = __webpack_public_path__ + "img/hina kagiyama.fd78b51b.png";